<template>
  <div class="home">
    <getstartForm />
  </div>
</template>

<script>
// @ is an alias to /src
import getstartForm from '@/components/auth/getstartForm.vue';

export default {
    name: 'get-started',
    components: {
        getstartForm
    }
};
</script>
